import { alias, primitive, serializable, object } from 'serializr';
import { SubjectModel } from '../CourseModels/SubjectModel/subject.model';

export class ExamModel {
    @serializable(alias('name', primitive()))
    name?: string
    @serializable(alias('id', primitive()))
    id?: string
    @serializable(alias('is_active', primitive()))
    isActive?: string
    @serializable(alias('exam_subject_count', primitive()))
    examSubjectCount?: string
    @serializable(alias('display_picture_url', primitive()))
    displayPictureUrl?: string
    @serializable(alias('description', primitive()))
    description?: string
    @serializable(alias('acronym', primitive()))
    acronym?: string
    @serializable(alias('amount', primitive()))
    amount?: string
    @serializable(alias('amount_paise', primitive()))
    amountPaise?: string
    @serializable(alias('amount_rupees', primitive()))
    amountRupees?: string

}


export class ExamSubjectModel {
    @serializable(alias('id', primitive()))
    id?: string;
    @serializable(alias('subject_name', primitive()))
    name?: string;
    @serializable(alias('amount_paise', primitive()))
    amountPaise?: string;
    @serializable(alias('amount_rupees', primitive()))
    amountRupees?: string;
    @serializable(alias('amount', primitive()))
    amount?: number;
    @serializable(alias('is_active', primitive()))
    isActive?: boolean;
    @serializable(alias('exam_chapter_count', primitive()))
    examChapterCount?: boolean;
    @serializable(alias('exam', object(ExamModel)))
    exam?: string;
    @serializable(alias('subject', object(SubjectModel)))
    subject?: SubjectModel
}
export class NewExamSubjectModel {
    @serializable(alias('amount', primitive()))
    amount?: number;
    @serializable(alias('is_active', primitive()))
    isActive?: boolean;
    @serializable(alias('exam_id', primitive()))
    examId?: number;
    @serializable(alias('subject_stream_id', primitive()))
    subjectStreamId?: number;
    @serializable(alias('subject_id', primitive()))
    subjectId?: number;
    @serializable(alias('name', primitive()))
    name?: number;
}